import { useEffect, useContext } from 'react'
import { useImmerReducer } from 'use-immer'

import { ModalManagerContext } from '../../ModalsManager'
import defaultState from './defaultState'
import reducer from './reducer'
import { GET_PLACEMENTS } from './actions'
import useFetch from '../../../utils/useFetch'


const placementUrl = `${process.env.REACT_APP_API_URL}/placement`

const usePlacement = () => {
  const [state, dispatch] = useImmerReducer(reducer, defaultState)
  const openModal = useContext(ModalManagerContext)
  const { render, data } = useFetch(placementUrl, openModal)

  useEffect(() => {
    if (data) {
      dispatch({ type: GET_PLACEMENTS, data })
    }
  }, [data, dispatch])

  return { state, dispatch, render }
}

export default usePlacement
